import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { getServerTranslations } from '../../../get-server-side-translations';
import { EmployerSecondaryLayout } from '../../../layouts';
import ReferralPageContent from '../../../components/referral/referral-page-content';

const ReferralPage: React.FunctionComponent = () => {
  const { t } = useTranslation('referral-page');

  return (
    <EmployerSecondaryLayout title={t('page_title')}>
      <ReferralPageContent />
    </EmployerSecondaryLayout>
  );
};

export default ReferralPage;

export const getStaticProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'referral-page']);
  return {
    props: {
      ...transConfig,
    },
  };
};
